<template>
  <router-view />
</template>

<script>
import storeMixin, { unRegisterMixin } from '@/shared/mixins/storeGenerator';
const STORE_MODULE_NAME = 'OperationsModule';

export default {
  name: 'OperationsWrapper',
  mixins: [unRegisterMixin, storeMixin],
  data: () => ({
    moduleName: STORE_MODULE_NAME,
  }),
};
</script>
